import { loadAndCacheImage } from '../../../loaders/imageLoader';
import { createAndCacheVolume } from '../../../loaders/volumeLoader';
import { ActorRenderMode } from '../../../types';
import resolveViewportVolumeId from '../../helpers/resolveViewportVolumeId';
import { getGenericViewportPlanarDataSet } from '../genericViewportDataSetAccess';
export class DefaultPlanarDataProvider {
    async load(dataId, options) {
        const dataSet = this.getDataSet(dataId);
        if (!dataSet) {
            throw new Error(`[PlanarViewport] No registered planar dataset for ${dataId}`);
        }
        if (!options) {
            throw new Error(`[PlanarViewport] No load options were provided for ${dataId}`);
        }
        if (!dataSet.imageIds.length) {
            throw new Error('[PlanarViewport] Cannot load an empty planar dataset');
        }
        const clampedImageIdIndex = Math.min(Math.max(0, dataSet.initialImageIdIndex ?? 0), dataSet.imageIds.length - 1);
        if (options.renderMode === ActorRenderMode.VTK_VOLUME_SLICE ||
            options.renderMode === ActorRenderMode.CPU_VOLUME) {
            const volumeId = resolveViewportVolumeId(options.volumeId);
            const imageVolume = await createAndCacheVolume(volumeId, {
                imageIds: dataSet.imageIds,
            });
            imageVolume.load();
            const imageIds = imageVolume.imageIds
                ? imageVolume.imageIds
                : dataSet.imageIds;
            return {
                id: dataId,
                type: 'image',
                imageIds,
                initialImageIdIndex: clampedImageIdIndex,
                acquisitionOrientation: options.acquisitionOrientation,
                imageData: dataSet.imageData,
                imageVolume,
                reference: dataSet.reference,
                renderMode: options.renderMode,
                useWorldCoordinateImageData: dataSet.useWorldCoordinateImageData,
                volumeId,
            };
        }
        const image = dataSet.image &&
            dataSet.image.imageId === dataSet.imageIds[clampedImageIdIndex]
            ? dataSet.image
            : await loadAndCacheImage(dataSet.imageIds[clampedImageIdIndex]);
        return {
            id: dataId,
            type: 'image',
            imageIds: dataSet.imageIds,
            image,
            imageData: dataSet.imageData,
            initialImageIdIndex: clampedImageIdIndex,
            acquisitionOrientation: options.acquisitionOrientation,
            reference: dataSet.reference,
            renderMode: options.renderMode,
            useWorldCoordinateImageData: dataSet.useWorldCoordinateImageData,
            volumeId: options.volumeId,
        };
    }
    getDataSet(dataId) {
        const dataSet = getGenericViewportPlanarDataSet(dataId);
        if (!isPlanarRegisteredDataSet(dataSet)) {
            return;
        }
        return dataSet;
    }
}
function isPlanarRegisteredDataSet(value) {
    if (!value ||
        typeof value !== 'object' ||
        !Array.isArray(value.imageIds) ||
        value.imageIds.length === 0) {
        return false;
    }
    const dataSet = value;
    return ((dataSet.initialImageIdIndex === undefined ||
        typeof dataSet.initialImageIdIndex === 'number') &&
        (dataSet.volumeId === undefined || typeof dataSet.volumeId === 'string'));
}
